export default "__VITE_PUBLIC_ASSET__3fdd056b__"